import { BaseService } from '../BaseService';
import { createSingleton } from '../singleton';
import { isServerKnownUnreachable, pingServer } from '@bi/sync';
let _strategy = 'always-online';
let _instance = null;
function getOnlineByStrategy() {
    if (_strategy === 'always-online')
        return true;
    return !isServerKnownUnreachable();
}
export class OnlineCheckService extends BaseService {
    static MODEL;
    _pingInFlight = null;
    constructor() {
        super(getOnlineByStrategy());
    }
    static setStrategy(strategy) {
        _strategy = strategy;
        _instance?.sync();
    }
    setOnline(online) {
        this._setModel(Boolean(online));
    }
    sync() {
        const online = getOnlineByStrategy();
        this.setOnline(online);
        return online;
    }
    ping() {
        if (this._pingInFlight)
            return this._pingInFlight;
        this._pingInFlight = Promise.resolve()
            .then(() => _strategy === 'always-online' ? true : pingServer())
            .then(Boolean)
            .catch(() => false)
            .then((online) => {
            this.setOnline(online);
            return online;
        })
            .finally(() => {
            this._pingInFlight = null;
        });
        return this._pingInFlight;
    }
    static getInstance = createSingleton(() => {
        _instance = new OnlineCheckService();
        return _instance;
    }, '__onlineCheckService');
}
